<template>
  <section class="become-a-teacher-section">
    <b-row class="p-0 m-0">
      <b-col cols="12" lg="4" class="p-0 m-0 order-1 order-lg-0">
        <div class="left">
          <h4 class="heading squiggly-line-white">Become a Teacher</h4>
          <b-form
            @submit="action('register')"
            @reset="onReset"
            v-if="show"
            class="text-white"
            data-vv-scope="register"
          >
            <b-form-group id="input-group-2" label="" label-for="teacher-name">
              <b-form-input
                id="teacher-name"
                v-model.trim="form.name"
                placeholder="Name*"
                v-validate="'required|alpha_spaces|min:3|max:20'"
                :class="{ 'is-invalid': errors.has('register.Name') }"
                name="Name"
              ></b-form-input>
              <b-form-invalid-feedback id="teacher-name-live-feedback">
                <small>{{ errors.first("register.Name") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              id="input-group-1"
              label=""
              label-for="teacher-email"
              description=""
            >
              <b-form-input
                id="teacher-email"
                v-model="form.email"
                type="email"
                placeholder="Email*"
                v-validate="'required|email'"
                name="Email"
                :class="{ 'is-invalid': errors.has('register.Email') }"
              ></b-form-input>
              <b-form-invalid-feedback id="teacher-email-live-feedback">
                <small>{{ errors.first("register.Email") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              id="input-group-x"
              label=""
              label-for="teacher-password"
              description=""
            >
              <b-form-input
                id="teacher-password"
                v-model="form.password"
                type="password"
                placeholder="Password*"
                v-validate="'required|min:8'"
                name="Password"
                ref="password"
                :class="{ 'is-invalid': errors.has('register.Password') }"
              ></b-form-input>
              <b-form-invalid-feedback id="teacher-passwod-live-feedback">
                <small>{{ errors.first("register.Password") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              id="input-group-z"
              label=""
              label-for="teacher-repassword"
              description=""
            >
              <b-form-input
                id="teacher-repassword"
                v-model="form.confirm_password"
                type="password"
                placeholder="Re-Password*"
                v-validate="'required|confirmed:password'"
                name="Re-password"
                :class="{ 'is-invalid': errors.has('register.Re-password') }"
              ></b-form-input>
              <b-form-invalid-feedback id="teacher-Re-password-live-feedback">
                <small>{{ errors.first("register.Re-password") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="input-group-q" label="" label-for="input-5">
              <b-form-input
                id="teacher-mobile_number"
                v-model="form.mobile_number"
                v-validate="'required||min:10|max:10|numeric'"
                placeholder="Mobile Number*"
                name="Mobile Number"
                :class="{ 'is-invalid': errors.has('register.Mobile Number') }"
              ></b-form-input>
              <b-form-invalid-feedback id="teacher-Mobile-Number-live-feedback">
                <small>{{ errors.first("register.Mobile Number") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group id="input-group-5" label="" label-for="input-5">
              <b-form-input
                id="teacher-location"
                v-model="form.location"
                v-validate="'required|alpha|min:3|max:20'"
                placeholder="Location*"
                name="Location"
                :class="{ 'is-invalid': errors.has('register.Location') }"
              ></b-form-input>
              <b-form-invalid-feedback id="teacher-location-live-feedback">
                <small>{{ errors.first("register.Location") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="input-group-3" label="" label-for="input-3">
              <!-- <b-form-select
                id="input-3"
                v-model="form.subjects"
                :options="subjects"
                required
              ></b-form-select> -->
              <v-select
                id="teacher-subjects"
                v-model="form.subjects"
                :options="subjects"
                :close-on-select="false"
                :multiple="true"
                placeholder="Subject of interest*"
                name="Subjects"
              />
              <div
                id="teacher-Subjects-live-feedback"
                v-if="!(form.subjects.length > 0) && showRegisterError"
              >
                <small style="color: black;font-size: .6em">
                  Choose At least one Subject
                </small>
              </div>
            </b-form-group>

            <b-form-group style="position: relative"
              id="input-group-4"
              label="Upload Resume"
              label-for="teacher-resume"
            >
              <b-form-file
                id="teacher-resume"
                accept=".pdf, .doc"
                v-model="resume"
                :state="Boolean(resume)"
                placeholder="Browse Resume"
                drop-placeholder="Drop file here..."
                v-validate="'required|ext:pdf,doc'"
                class="custom-file-input-form"
                :class="{ 'is-invalid': errors.has('register.Resume') ,  'no-after' : disableButton}"
                name="Resume"
                type="file"
                @change="uploadResume"
              ></b-form-file>
              <div style="position: absolute;right: 12px;bottom: 12px;z-index: 10000" v-if="disableButton">
                <b-spinner style="color: red; width: 1.5rem;height: 1.5rem" label="Spinning"></b-spinner>
              </div>
              <div
                class="invalid-feedback"
                style="display: block"
                id="teacher-location-live-feedback"
              >
                <small>{{ errors.first("register.Resume") }}</small>
              </div>
            </b-form-group>
            <div
            id="teacher-resume-live-feedback"
            v-if="!resume && showRegisterError"
            >
            <small style="color: black;font-size:.6em"
            >Resume must be uploaded</small
            >
            </div>


            <!--<b-form-group-->
            <!--id="input-group-6"-->
            <!--label="Upload a sample video"-->
            <!--label-for="input-6"-->
            <!--&gt;-->
            <!--<b-form-file-->
            <!--id="input-6"-->
            <!--v-model="form.resume"-->
            <!--accept="video/*"-->
            <!--:state="Boolean(form.resume)"-->
            <!--placeholder="Upload Video"-->
            <!--drop-placeholder="Drop file here..."-->
            <!--&gt;</b-form-file>-->
            <!--</b-form-group>-->

            <b-button
              size="lg"
              pill
              variant="primary"
              type="submit"
              @click.prevent="action('register')"
              :disabled="disableButton"
              v-if="!showOtpField"
            >
              <div v-if="!showSpinner">
                <span>Apply Now</span>
                <font-awesome-icon icon="arrow-right" size="xs" />
              </div>
              <div class="d-flex align-center" v-else>
                <b-spinner variant="light"></b-spinner
                ><span>Registering...</span>
              </div>
            </b-button>
          </b-form>
          <otp-form v-if="showOtpField" :phone_number="form.mobile_number" @signUp="teacherSignUp"></otp-form>
        </div>
      </b-col>
      <b-col cols="12" lg="8" class="p-0 m-0 order-0 order-lg-1">
        <div class="right">
          <h4 class="heading squiggly-line-color">Your Benefits</h4>
          <b-row class="border-bottom">
            <b-col cols="6" v-for="benefit in benefits" :key="benefit.title">
              <div class="benfits-card">
                <div class="benfits-card-img">
                  <img :src="benefit.img" alt="" />
                </div>
                <div class="benfits-card-title">
                  <p>{{ benefit.title }}</p>
                </div>
              </div>
            </b-col>
          </b-row>
          <h4 class="heading">How it works</h4>
          <video src="https://s3.ap-south-1.amazonaws.com/tst-edfore/video/Edweena Martin5286/video/Edweena Martin5286_SampleVideo_720x480_2mb.mp4"
                 autoplay controls style="width: 100%"></video>
          <div class="features-list">
            <div class="first">
              <b-img
                src="img/icons/svg/check-icon.svg"
                fluid
                alt="Computer image"
              ></b-img>
              <span>Resume Submission</span>
            </div>
            <div class="second">
              <b-img
                src="img/icons/svg/check-icon.svg"
                fluid
                alt="Bulb image"
              ></b-img>
              <span>Invitation for Interview</span>
            </div>
            <div class="third">
              <b-img
                src="img/icons/svg/check-icon.svg"
                fluid
                alt="Live image"
              ></b-img>
              <span>Joining Letter</span>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <register-success-modal :email="form.email"></register-success-modal>
  </section>
</template>

<script>
import { teacherApi } from "../services/teacherApi";
import { authenticationApi } from "../services/authenticationApi";
import { mapGetters } from "vuex";
import RegisterSuccessModal from "../components/modals/RegisterSuccesModal";
import OtpForm from "../components/Templates/OtpForm";
export default {
  components: {
      OtpForm,
      RegisterSuccessModal },
  data() {
    return {
      title: "Contribute as a teacher and earn money",
      resume: "",
      disableButton: false,
      form: {
        email: "",
        name: "",
        location: "",
        subjects: [],
        resume: "",
        password: "",
        confirm_password: "",
        mobile_number: ""
      },
      subjects: [],
      show: true,
      showRegisterError: false,
      benefits: [
        {
          img: "img/icons/png/point1.png",
          title: "Earn passive Income"
        },
        {
          img: "img/icons/png/point4.png",
          title: "Showcase your Expertise"
        },
        {
          img: "img/icons/png/point2.png",
          title: "Bonus Scheme"
        },
        {
          img: "img/icons/png/point3.png",
          title: "Private health Care"
        }
      ],
      showSpinner: false,
        showOtpField:false
    };
  },
  methods: {
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.subjects = [];
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result && this.form.subjects.length > 0 && this.resume) {
          this.showRegisterError = false;
          this.sendOTP();
          this.showOtpField = true;
        } else {
          this.showRegisterError = true;
        }
      });
    },
    uploadResume(e) {
      this.disableButton = true;
      const formData = new FormData();
      formData.append("document", e.target.files[0]);
      teacherApi
        .uploadResume(formData)
        .then(res => {
          this.disableButton = false;
          this.form.resume = res.bodyText;
        })
        .catch(e => {
          console.error("resume upload api fail", e);
        });
    },
    teacherSignUp() {
      this.showSpinner = true;
      this.showOtpField = false;
      const userData = {
        name: this.form.name,
        resume: this.form.resume,
        email: this.form.email,
        location: this.form.location,
        subject: this.form.subjects,
        password: this.form.password,
        confirm_password: this.form.confirm_password,
        mobile_number: this.form.mobile_number,
        role: "teacher"
      };
      teacherApi
        .teacherSignUp(userData)
        .then(() => {
          this.showSpinner = false;
          this.$bvModal.show("registration-success-modal");
        })
        .catch(e => {
          this.showSpinner = false;
          this.showRegisterError = false;
          this.$bvToast.toast(`Sign up Failed  ${e.body.message}`, {
            title: "Become a Teacher",
            variant: "danger",
            autoHideDelay: 500,
            appendToast: true
          });
          this.resetForm();
          console.error("signup fail", e);
        });
    },
      sendOTP(){
          let otpdata = {
              phone_number : this.form.mobile_number,
          };
          this.showOtpField = true;
          authenticationApi.sendOTP(otpdata).then(res => {
              console.log("otp send successfully",res)
          })
      },
    resetForm() {
      this.form.name = "";
      this.form.resume = "";
      this.form.email = "";
      this.form.location = "";
      this.form.subjects = [];
      this.form.password = "";
      this.form.confirm_password = "";
      this.form.mobile_number = "";
      this.resume = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  mounted() {
    // this.$emit("changeTitle", this.title);
    this.$route.meta.title = "This is a new title";
    this.getCategoryData.forEach(category => {
      category.sub_category.forEach(sub => {
        this.subjects.push(sub.name);
      });
    });
  },
  computed: {
    ...mapGetters("category", ["getCategoryData"])
  }
};
</script>

<style></style>
